<template>
  <el-main id="home">
    <!-- banner图 -->
    <div class="banner">
      <img src="./../assets/home/banner.png" :alt="SystemOption.seoKeyWord" />
      <!-- <video autoplay muted loop>
        <source src="./../assets/home/banner.mp4" type="video/mp4" />
      </video> -->
      <!-- <div class="shubiaoImg">
        <img
          src="./../assets/home/donagtai.gif"
          :alt="SystemOption.seoKeyWord"
        />
      </div> -->
    </div>
    <!-- 介绍introduce -->
    <div class="introduce">
      <div class="title">
        <div class="title-CHname">盈科介绍</div>
        <div class="title-ENname">INTRODUCE</div>
        <div class="title-line"></div>
        <div class="arrow">
          <router-link to="/introduce/yksz.html">
            <img src="./../assets/mobile/arrow.png" alt />
          </router-link>
        </div>
      </div>
      <div class="content">
        <div class="introduce-img">
          <img src="./../assets/home/Ykjiehsao.png" alt />
        </div>
        <div class="introduce-text">{{ Introduce }}</div>
      </div>
    </div>
    <!-- 专业领域 -->
    <div class="professionalfield">
      <img
        class="centerlogo"
        src="./../assets/home/ykbiglogo.png"
        :alt="SystemOption.seoKeyWord"
      />
      <div class="title">
        <div class="title-CHname">专业领域</div>
        <div class="title-ENname">PROFESSIONAL FIELD</div>
        <div class="title-line"></div>
        <div class="arrow">
          <router-link to="/field.html">
            <img src="./../assets/mobile/arrowLight.png" alt />
          </router-link>
        </div>
      </div>
      <div class="content">
        <div class="item" v-for="(x, i) in Professionalfield" :key="i">
          <img class="item-img" :src="Url.imgUrl + x.logo" />
          <div class="item-text">
            <div class="item-text-tit">{{ x.name }}</div>
            <div class="item-text-infor">{{ x.description }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 专业团队team -->
    <div class="team">
      <div class="title">
        <div class="title-CHname">专业团队</div>
        <div class="title-ENname">PROFESSIONAL TEAM</div>
        <div class="title-line"></div>
        <div class="arrow">
          <router-link to="/team.html">
            <img src="./../assets/mobile/arrow.png" alt />
          </router-link>
        </div>
      </div>
      <div class="content">
        <div
          class="content-item"
          v-for="(x, i) in Lawyers"
          :key="i"
          @click="toTeamDetail(x.id)"
        >
          <img :src="Url.imgUrl + x.photo" :alt="x.keyWords" />
          <img
            class="mobile-UserImg"
            :src="Url.imgUrl + x.photo"
            :alt="x.keyWords"
          />
          <div class="content-item-tit">{{ x.name }}</div>
        </div>
      </div>
      <router-link to="/team.html">
        <div class="more">查看更多</div>
      </router-link>
    </div>
    <!-- 经典案例case -->
    <div class="case">
      <div class="title">
        <div class="title-CHname">经典案例</div>
        <div class="title-ENname">CLASSIC CASE</div>
        <div class="title-line"></div>
        <div class="arrow">
          <router-link to="/case.html">
            <img
              src="./../assets/mobile/arrowLight.png"
              :alt="SystemOption.seoKeyWord"
            />
          </router-link>
        </div>
      </div>
      <div class="content">
        <div class="selectList">
          <div
            class="selectListOption"
            :class="{ act: CaseChanged == i }"
            @click="CaseChange(i, item.id)"
            v-for="(item, i) in Professionalfield"
            :key="i"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="optionBox">
          <div
            class="optionBoxItem"
            v-for="(x, i) in CaseList"
            :key="i"
            @click="toCaseDetail(x.id)"
          >
            <div class="tit">{{ x.title }}</div>
            <div class="text" v-html="x.intro"></div>
            <div class="time">
              {{
                x.publishTime == undefined ||
                x.publishTime == null ||
                x.publishTime == ""
                  ? ""
                  : x.publishTime.split("T")[0]
              }}
            </div>
          </div>
          <div class="NoTextImg" v-if="CaseNoText">
            <img
              class=""
              src="./../assets/home/NoTextImg.png"
              :alt="SystemOption.seoKeyWord"
            />
            <p style="margin-right: 8px">
              <img
                class=""
                src="./../assets/home/Notext.png"
                :alt="SystemOption.seoKeyWord"
              />
            </p>
          </div>
        </div>
      </div>
      <router-link to="/case.html">
        <div class="more">查看更多</div>
      </router-link>
    </div>
    <!-- 盈科动态 -->
    <div class="dynamic">
      <!-- <div class="titleList">
				<div class="title" style="" v-for="(x,i) in titleList" :key="i" @click="TiTchoose(i)">
					<div class="title-CHname">{{x.name}}</div>
					<div class="title-ENname" v-html="x.Enname"></div>
					<div class="title-line" ></div>
				</div>
			</div>
			<div class="newdynamicBox">
				<div class="content" style="">
					<div class="item" v-for="(x,i) in dynamic" :key="i">
						<div class="itemTIme">{{x.publishtime==undefined || x.publishtime==null || x.publishtime=='' ? '' :x.publishtime.split("T")[0]}}</div>
						<div class="itemText">
								<div class="title" @click="toArticleDeatil(x.id,'dynamic')">{{x.title}}</div>
							<div>{{x.describe}}</div>
						</div>
					</div>
				</div>
				<div class="content" style="">
					<div class="item" v-for="(x,i) in party" :key="i">
						<div class="itemTIme">{{x.publishtime==undefined || x.publishtime==null || x.publishtime=='' ? '' :x.publishtime.split("T")[0]}}</div>
						<div class="itemText">
							<div class="title" @click="toArticleDeatil(x.id,'party')">{{x.title}}</div>
							<div>{{x.describe}}</div>
						</div>
					</div>
				</div>	
			</div> -->
      <!-- <div class="more" @click="changked==0?$router.push({path:'/dynamic.html'}):$router.push({path:'/party.html'})">查看更多</div> -->

      <div class="newdynamicBox">
        <div class="Box-item">
          <div class="title">
            <div class="title-CHname">律所动态</div>
            <div class="title-ENname">DYNAMEIC</div>
            <div class="title-line"></div>
          </div>
          <div class="lsit">
            <div class="lsitItem" v-for="(x, i) in dynamic" :key="i">
              <div class="ItemTitle" @click="toArticleDeatil(x.id, 'dynamic')">
                {{ x.title }}
              </div>
              <div class="ItemTime">{{ x.publishtime }}</div>
            </div>
            <div class="more" @click="$router.push({ path: '/dynamic.html' })">
              查看更多
            </div>
          </div>
        </div>
        <div class="Box-item">
          <div class="title">
            <div class="title-CHname">党建专区</div>
            <div class="title-ENname">THE ZONE</div>
            <div class="title-line"></div>
          </div>
          <div class="lsit">
            <div class="lsitItem" v-for="(x, i) in party" :key="i">
              <div class="ItemTitle" @click="toArticleDeatil1(x.id, 'party')">
                {{ x.title }}
              </div>
              <div class="ItemTime">{{ x.publishtime }}</div>
            </div>
            <div class="more" @click="$router.push({ path: '/party.html' })">
              查看更多
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 案件咨询 -->
    <div class="consulting">
      <div class="title">
        <div class="title-CHname">案件咨询</div>
        <div class="title-ENname">CONSULTING</div>
        <div class="title-line"></div>
      </div>
      <div class="content">
        <div class="Item-tel">
          <div class="tel-Num">
            <div class>法律咨询电话</div>
            <div class>
              <div>0755-36866534</div>
              <div>400-838-0148</div>
            </div>
          </div>
          <img src="../assets/home/tel.png" :alt="SystemOption.seoKeyWord" />
        </div>
        <div class="Item-from">
          <el-form>
            <el-row class="Item-flex">
              <el-col>
                <el-form-item>
                  <el-input
                    class="item-input"
                    v-model="form.username"
                    placeholder="您的姓名"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item>
									<el-input placeholder="您的邮箱" v-model="form.email"></el-input>
								</el-form-item> -->
                <el-form-item>
                  <el-input placeholder="您的手机号码" v-model="form.phone">
                    <el-button @click="GetCode(form.phone)" slot="append">{{
                      isSendCode
                    }}</el-button>
                  </el-input>
                </el-form-item>

                <el-form-item>
                  <el-input
                    type="textarea"
                    placeholder="问题概述"
                    v-model="form.problemDes"
                  ></el-input>
                </el-form-item>

                <!-- <el-form-item>
									<el-input placeholder="您所在的公司" v-model="form.company"></el-input>
								</el-form-item> -->
              </el-col>
              <el-col>
                <el-form-item>
                  <el-select
                    v-model="form.advisoryType"
                    placeholder="咨询类别"
                    style="width: 100%"
                  >
                    <el-option label="民事" value="38"></el-option>
                    <el-option label="刑事" value="39"></el-option>
                    <el-option label="行政" value="40"></el-option>
                    <el-option label="其他" value="41"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    placeholder="您收到的验证码"
                    v-model="form.code"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    placeholder="您的位置"
                    v-model="form.address"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button
                    :style="disabled == true ? 'background:#888' : ''"
                    class="submit"
                    type="primary"
                    :disabled="disabled"
                    @click="onSubmit"
                    >发 送</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 右侧浮动图标组 -->
    <transition name="el-zoom-in-center">
      <div class="Icon_group" v-if="isDisFloat">
        <div class="Icon_item">
          <a href="tel:400-838-0148"
            ><img
              src="../assets/home/dianhua@3x.png"
              :alt="SystemOption.seoKeyWord"
          /></a>
        </div>
        <div class="Icon_item">
          <img
            @mouseover="isShowWXrcode = true"
            @mouseout="isShowWXrcode = false"
            src="../assets/home/weixin@3x.png"
            :alt="SystemOption.seoKeyWord"
          />
          <img
            v-if="isShowWXrcode"
            style="position: absolute; width: 143px; left: -164px; top: 54px"
            src="../assets/home/wxRode1.jpg"
            alt=""
          />
        </div>
        <div class="Icon_item" @click="backtop">
          <img src="../assets/home/top@3x.png" :alt="SystemOption.seoKeyWord" />
        </div>
      </div>
    </transition>
  </el-main>
</template>

<script>
// @ is an alias to /src
export default {
  name: "Home",
  comments: {},
  metaInfo() {
    return {
      title: `首页-${this.SystemOption.seoTitle ?? ""}`,
      meta: [
        {
          // set meta
          name: "keywords",
          content: this.SystemOption.seoKeyWord,
        },
        {
          // set meta
          name: "description",
          content: this.SystemOption.seoDescribe,
        },
      ],
    };
  },
  data() {
    return {
      select: "",
      titleList: [
        {
          id: 0,
          name: "律所动态",
          Enname: "DYNAMIC",
        },
        {
          id: 1,
          name: "党建专区",
          Enname: "THE&nbsp;&nbsp;&nbsp;ZONE",
        },
      ],
      changked: 0,
      CaseOptionList: [
        "争议解决法律事务",
        "金融法律事务",
        "资本市场法律事务",
        "刑事法律事务",
        "工程与房地产法律事务",
        "家族法律事务",
        "政府法律事务",
        "公司法律事务",
        "知识产权法律事务",
        "涉外法律事务",
      ],
      Introduce: "暂无内容", //盈科介绍
      Professionalfield: "暂无内容", //盈科介绍
      Lawyers: "暂无内容", //盈科团队
      CaseList: "暂无内容", //经典案例
      dynamic: "暂无内容", //律所动态
      party: "暂无内容", //党建专区
      SystemOption: [], //SEO配置
      CaseChanged: 0,
      CaseChangedid: 0,
      form: {
        //联系我们表单
        username: "",
        phone: "",
        address: "",
        advisoryType: "",
        problemDes: "",
        code: "",
      },
      isSendCode: "发送验证码",
      isDisFloat: false,
      isShowWXrcode: false, //是否悬浮显示微信二维码
      CaseNoText: false,
      disabled: false,
    };
  },
  methods: {
     getLocation(){//获取位置
      let _this = this;
      var aaa=localStorage.getItem("addwww");
     _this.form.address=aaa;
     },
    //获取随机 guid
    getGuid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      );
    },
    //获取验证码
    GetCode(phone) {
      let that = this;
      let guid = that.getGuid();
      that.guid = guid;
      if (this.form.phone == "") {
        alert("请填写手机号");
        return false;
      }
      this.isSendCode = "已发送";
      this.axios({
        type: "post",
        url: this.Url.apiUrl + "sms/code/"+that.guid+"",//http://localhost:8094/api/sms/code
        //url:
        //  "http://test-shenzhen.api.yingkelawyer.com/api/sms/code/" + guid + "", //测试 44接口地址
        //url: "http://localhost:8094/api/sms/code/" + guid + "", //测试 本地接口地址
        params: {
          phone: phone,
        },
      }).then((res) => {
        console.log(res);
      });
    },
    //提交表单
    onSubmit() {
      let that = this;
      if (this.form.username == "") {
        alert("请输入您的姓名");
        return false;
      }
      if (this.form.advisoryType == "") {
        alert("请选择咨询类别");
        return false;
      }
      if (this.form.phone == "") {
        alert("请填写您的手机号");
        return false;
      }
      if (this.form.code == "") {
        alert("请输入您收到的验证码");
        return false;
      }
      if (this.form.problemDes == "") {
        alert("请输入问题概述");
        return false;
      }
      this.disabled = true;
      //验证输入的验证码是否正确
      if (that.guid == undefined) {
        alert("发送失败,请重新输入您的信息");
        return false;
      }
      that
        .axios({
          type: "post",
          url: this.Url.apiUrl + "v/code/"+that.guid+"",
         // url:
          //  "http://test-shenzhen.api.yingkelawyer.com/api/v/code/" +
           // that.guid +
          //  "", //////////////////////////测试 44接口地址
          //url: "http://localhost:8094/api/v/code/"+that.guid+"",//////////////////////////测试 本地接口地址
          params: {
            phone: that.form.phone,
            code: that.form.code,
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            alert("验证码不正确,请重新输入");
            return false;
          } else {
            //提交表单
            that
              .axios({
                method: "post",
                url: this.Url.apiUrl + "SystemOption/CaseAdvisory",
               // url:
                //  "http://test-shenzhen.api.yingkelawyer.com/api/" +
                //  "SystemOption/CaseAdvisory", //测试 44接口地址
                data: that.form,
                headers: {
                  "Content-Type": "application/json",
                },
              })
              .then(() => {
                alert("提交成功");
                that.disabled = true;
              });
          }
        });
    },
    //案件选择
    CaseChange(i, item) {
      this.CaseChanged = i;
      this.axios({
        type: "get",
        url: this.Url.apiUrl + "Case/CaseTop?num=5&type=" + item + "",
      }).then((res) => {
        if (res.data.length == 0) {
          this.CaseNoText = true;
        } else {
          this.CaseNoText = false;
          res.data.forEach((element) => {
            if (element.describe.length == 0) {
              element.describe = "暂无描述";
            }
          });
        }

        this.CaseList = res.data;
      });
    },
    //律所动态&党建专区选择
    TiTchoose(e) {
      this.changked = e;
    },
    //回到顶部
    backtop() {
      // document.documentElement.scrollTop = 0;
      // document.body.scrollTop = 0;
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 10);
    },
    //滚动监听方法
    handleScroll() {
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop > 500
        ? (this.isDisFloat = true)
        : (this.isDisFloat = false);
    },
    //跳转专业团队详情
    toTeamDetail(id) {
      this.$router.push({
        path: "/team/all/:id.html",
        name: "team-all-details",
        component: () => import("../views/team/details.vue"),
        params: {
          id: id,
        },
      });
    },
    //跳转经典案例详情
    toCaseDetail(id) {
      this.$router.push({
        path: "/case/:caseType/:id.html",
        name: "Casedetail",
        component: () => import("../views/cases/details.vue"),
        params: {
          caseType: this.CaseChanged,
          id: id,
        },
      });
    },
    //跳转文章详情
    toArticleDeatil(id) {
      this.$router.push({
        path: "/:articleType/:order/:id.html",
        name: "article-details",
        component: () => import("../views/article/details.vue"),
        params: {
          id: id,
        },
      });
    },
    toArticleDeatil1(id) {
      this.$router.push({
        name: "article-details1",
        params: {
          id: id,
        },
      });
    },
    //获取地址
    // Tmap() {
    //   let _this = this;
    //   window.addEventListener(
    //     "message",
    //     function (event) {
    //       var loc = event.data;
    //       this.opp = loc.city;
    //       console.log(event.data.city);       
    //       _this.form.address = event.data.city;
    //       return event.data.city
    //     },
    //     false
    //   );
    // },
  },
  created() {
  //根据ip获取位置
  this.axios({
      type: "get",
      url: "https://restapi.amap.com/v3/ip?key=3bf7b13d0ae511ae362948dde79bdb14",
    }).then((res) => {
     let _this = this;
     var citys=res.data.city
     _this.form.address=citys;
    });
   
    let getCase = new Promise((reslove) => {
      //获取专业领域
      this.axios({
        type: "get",
        url: this.Url.apiUrl + "ProfessionalField/GetProfessionalField",
      }).then((res) => {
        res.data.forEach((element) => {
          if (element.description.length > 80) {
            element.description = element.description.substring(0, 80) + "...";
          }
        });
        this.Professionalfield = res.data;
        reslove(res.data);
      });
    });
    getCase.then((data) => {
      //获取经典案例TOP5
      this.axios({
        type: "get",
        url: this.Url.apiUrl + "Case/CaseTop?num=5&type=" + data[0].id + "",
      }).then((res) => {
        if (res.data.length == 0) {
          this.CaseNoText = true;
        } else {
          this.CaseNoText = false;
          res.data.forEach((element) => {
            if (element.describe.length == 0) {
              element.describe = "暂无描述";
            }
          });
        }
        this.CaseList = res.data;
      });
    });
    //获取盈科介绍
    this.axios({
      type: "get",
      url: this.Url.apiUrl + "Introduce/GetIntroduce",
    }).then((res) => {
      this.Introduce = res.data.contents
        .replace(/<[^>]+>/g, "")
        .replace(/&nbsp/g, "")
        .replace(";;;;;;;;", "");
    });
    //获取专业团队TOP5
    this.axios({
      type: "get",
      url: this.Url.apiUrl + "Lawyer/GetLawyersTop?num=5",
    }).then((res) => {
      console.log(res);
      this.Lawyers = res.data;
    });
    //获取律所动态TOP5
    this.axios({
      type: "get",
      url: this.Url.apiUrl + "Articles/GetTopArticles?type=1&num=5",
    }).then((res) => {
      this.dynamic = res.data;
      //获取党建专区TOP5
      this.axios({
        type: "get",
        url: this.Url.apiUrl + "Articles/GetTopArticles?type=2&num=5",
      }).then((res) => {
        this.party = res.data;
      });
    });

    //获取SEO配置
    this.axios
      .get(this.Url.apiUrl + "SystemOption/GetSystemOption")
      .then((res) => (this.SystemOption = res.data));
  },
  mounted() {
    //添加滚动监听
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss" scoped>
.el-main {
  .banner {
    position: relative;
    height: 900px;
    overflow: hidden;
    top: -40px;
    z-index: -6;

    @media screen and (max-width: 1300px) {
      top: -53px;
      height: auto;
    }

    @media screen and (max-width: 768px) {
      top: 0px;
      height: 167px;
    }

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;

      @media screen and (max-width: 1300px) {
        object-fit: contain;
      }

      @media screen and (max-width: 768px) {
        display: none;
      }
    }

    > img {
      // display: none;
      width: 100%;
      height: 100%;
  object-fit: cover;
      @media screen and (max-width: 768px) {
        display: block;
      }
    }

    .shubiaoImg {
      position: absolute;
      left: 50%;
      top: 90%;
      z-index: 999999;
      transform: translate(-50%, -50%);
      cursor: pointer;
      @media screen and (max-width: 768px) {
        display: none;
      }

      img {
        cursor: pointer;
        user-select: none;
        width: 32px;
        height: 56px;
      }
    }
  }

  .introduce {
    height: 630px;
    background: #fff;
    padding: 50px 0;

    @media screen and (max-width: 1300px) {
      padding: 10px 0;
    }
    @media screen and (max-width: 768px) {
      padding: 26px 36px;
      height: auto;
    }

    .title {
      color: #bd9d6c;
      font-size: 20px;
      text-align: center;
      margin-bottom: 18px;
      position: relative;

      @media screen and (max-width: 768px) {
        display: flex;
        font-size: 16px;
        margin-bottom: 14px;
      }

      .title-CHname {
        font-weight: 600;

        @media screen and (max-width: 768px) {
          margin-right: 10px;
        }
      }

      .title-ENname {
        line-height: 30px;
        margin-bottom: 15px;
        font-size: 18px;
      }

      .title-line {
        width: 35px;
        height: 1px;
        background-color: #bd9d6c;
        margin: 0 auto;

        @media screen and (max-width: 768px) {
          display: none;
        }
      }

      .arrow {
        display: none;

        @media screen and (max-width: 768px) {
          display: block;
          width: 23.3px;
          height: 14.33px;
          position: absolute;
          right: 0px;
          top: 10px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .content {
      position: relative;
      width: 1200px;
      height: 390px;
      display: flex;
      justify-content: space-between;
      margin: 0 auto;

      @media screen and (max-width: 768px) {
        position: relative;
        width: 100%;
        height: auto;
        flex-direction: column;
        justify-content: space-between;
      }

      .introduce-img {
        flex: 0 0 420px;
        width: 420px;
        height: 100%;
        overflow: hidden;
        border-radius: 3px;
        background-color: #888;

        @media screen and (max-width: 768px) {
          flex: 0 0 280px;
          width: 100%;
          overflow: hidden;
          border-radius: 0px;

          img {
            width: 100%;
            height: auto;
          }
        }
      }

      .introduce-text {
        flex: 0 0 738px;
        width: 738px;
        height: 100%;
        font-size: 15px;
        color: #a5a5a5;
        line-height: 34px;
        text-indent: 49px;
        @media screen and (max-width: 768px) {
          margin-top: 10px;
          font-size: 13px;
          flex: auto;
          width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }

  .professionalfield {
    position: relative;
    height: 730px;
    padding: 50px 0;
    background: url("./../assets/home/zylybg.png");
    background-size: 100% 100%;

    @media screen and (max-width: 768px) {
      position: relative;
      padding: 24px 21px;
      height: auto;
    }

    .centerlogo {
      width: 10rem;
      height: 10rem;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      @media screen and (max-width: 768px) {
        display: none;
      }
    }

    .title {
      color: #ffffff;
      font-size: 20px;
      text-align: center;
      margin-bottom: 18px;
      position: relative;

      @media screen and (max-width: 768px) {
        font-size: 16px;
        display: flex;
        align-items: center;
      }

      .title-CHname {
        font-weight: 600;

        @media screen and (max-width: 768px) {
          margin-right: 10px;
        }
      }

      .title-ENname {
        line-height: 30px;
        margin-bottom: 15px;
        font-size: 18px;

        @media screen and (max-width: 768px) {
          border-bottom: 1px solid #fff;
          margin-bottom: 0px;
        }
      }

      .title-line {
        width: 35px;
        height: 1px;
        background-color: #ffffff;
        margin: 0 auto;

        @media screen and (max-width: 768px) {
          display: none;
        }
      }

      .arrow {
        display: none;

        @media screen and (max-width: 768px) {
          display: block;
          width: 23.3px;
          height: 14.33px;
          position: absolute;
          right: 0px;
          top: 10px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .content {
      position: relative;
      width: 1200px;
      height: 496px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;

      @media screen and (max-width: 768px) {
        position: relative;
        width: auto;
        height: auto;
        overflow: hidden;
      }

      .item {
        flex: 0 0 50%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 70px;

        @media screen and (max-width: 768px) {
          height: 50px;
          flex: 0 0 50%;
        }

        .item-img {
          flex: 0 0 60px;
          height: 60px;
          margin: 0 26px 0 0px;

          @media screen and (max-width: 768px) {
            flex: 0 0 23px;
            height: 23px;
            margin: 0 10px 0 0px;
          }
        }

        .item-text {
          width: 363px;

          @media screen and (max-width: 768px) {
            width: auto;
          }

          .item-text-tit {
            font-size: 14px;
            color: #e2ba6a;
            line-height: 25px;

            @media screen and (max-width: 768px) {
              color: #fff;
              font-size: 12px;
            }
          }

          .item-text-infor {
            font-size: 12px;
            height: 50px;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #fff;

            @media screen and (max-width: 768px) {
              display: none;
            }
          }
        }
      }

      .item:nth-of-type(even) {
        justify-content: flex-start;
        flex-direction: row-reverse;

        .item-img {
          margin: 0 0 0 11px;
        }
      }
    }
  }

  .team {
    position: relative;
    height: 539px;
    padding: 50px 0;

    @media screen and (max-width: 768px) {
      padding: 24px 21px;
      height: auto;
    }

    .title {
      color: #bd9d6c;
      font-size: 20px;
      text-align: center;
      margin-bottom: 28px;
      position: relative;

      @media screen and (max-width: 768px) {
        display: flex;
        font-size: 16px;
        margin-bottom: 26px;
      }

      .title-CHname {
        font-weight: 600;

        @media screen and (max-width: 768px) {
          margin-right: 10px;
        }
      }

      .title-ENname {
        line-height: 30px;
        margin-bottom: 15px;
        font-size: 18px;
      }

      .title-line {
        width: 35px;
        height: 1px;
        background-color: #bd9d6c;
        margin: 0 auto;

        @media screen and (max-width: 768px) {
          display: none;
        }
      }

      .arrow {
        display: none;

        @media screen and (max-width: 768px) {
          display: block;
          width: 23.3px;
          height: 14.33px;
          position: absolute;
          right: 0px;
          top: 10px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .content {
      position: relative;
      width: 1200px;
      height: 301px;
      background: #fff;
      margin: 0 auto;
      display: flex;
      flex-wrap: nowrap;
      overflow: hidden;
      justify-content: space-between;

      @media screen and (max-width: 768px) {
        position: relative;
        width: 100%;
        height: auto;
        flex-wrap: wrap;
      }

      .content-item {
        flex: 0 0 220px;
        height: 301px;
        position: relative;
        overflow: hidden;
        margin: 0 10px;
        cursor: pointer;

        @media screen and (max-width: 768px) {
          flex: 0 0 148px;
          width: 100%;
          height: 165px;
          flex-wrap: wrap;
          margin: 5px 0;
        }

        img {
          width: 100%;
          height: auto;

          @media screen and (max-width: 768px) {
            display: none;
            width: 100%;
          }
        }
        img:hover {
          transition: 300ms;
          transform: scale(1.1);
        }

        .mobile-UserImg {
          display: none;

          @media screen and (max-width: 768px) {
            display: block;
          }
        }

        .content-item-tit {
          height: 41px;
          background-color: rgba(0, 0, 0, 0.5);
          position: absolute;
          bottom: 0;
          width: 100%;
          line-height: 41px;
          text-align: center;
          font-size: 14px;
          color: #ffffff;

          @media screen and (max-width: 768px) {
            flex: 0 0 148px;
            width: 100%;
            height: 23.6px;
            font-size: 13px;
            line-height: 27.6px;
            flex-wrap: wrap;
          }
        }
        .content-item-tit:hover {
          transition: 300ms;
          background-color: rgba(0, 0, 0, 0.8);
        }
      }
    }

    .more {
      width: 120px;
      height: 32px;
      border: solid 1px #be9d6d;
      color: #be9d6d;
      line-height: 32px;
      text-align: center;
      margin: 30px auto 0 auto;
      font-weight: 600;
      cursor: pointer;
    }
  }

  .case {
    padding: 50px 0;
    background: url("./../assets/home/jdalbg.png");
    background-size: 100% 100%;
    height: 680px;

    @media screen and (max-width: 768px) {
      padding: 24px 21px;
      height: auto;
    }

    .title {
      color: #ffffff;
      font-size: 20px;
      text-align: center;
      margin-bottom: 18px;
      position: relative;

      @media screen and (max-width: 768px) {
        font-size: 16px;
        display: flex;
        align-items: center;
      }

      .title-CHname {
        font-weight: 600;

        @media screen and (max-width: 768px) {
          margin-right: 10px;
        }
      }

      .title-ENname {
        line-height: 30px;
        margin-bottom: 15px;
        font-size: 18px;

        @media screen and (max-width: 768px) {
          border-bottom: 1px solid #fff;
          margin-bottom: 0px;
        }
      }

      .title-line {
        width: 35px;
        height: 1px;
        background-color: #ffffff;
        margin: 0 auto;

        @media screen and (max-width: 768px) {
          display: none;
        }
      }

      .arrow {
        display: none;

        @media screen and (max-width: 768px) {
          display: block;
          width: 23.3px;
          height: 14.33px;
          position: absolute;
          right: 0px;
          top: 10px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .content {
      position: relative;
      display: flex;
      justify-content: space-between;
      width: 1200px;
      height: 450px;
      margin: 0 auto;

      @media screen and (max-width: 768px) {
        position: relative;
        display: block;
        width: auto;
        height: auto;
      }

      .selectList {
        display: block;
        width: 230px;
        height: 100%;
        background-color: #cea15a;
        padding: 25px 0;
        box-sizing: border-box;
        overflow: hidden;

        @media screen and (max-width: 768px) {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          padding: 0px 0;
          background-color: rgba(206, 161, 90, 0.5);
        }

        .selectListOption {
          cursor: pointer;
          height: 35px;
          width: 100%;
          background-color: #cea15a;
          text-align: center;
          line-height: 35px;
          font-size: 14px;
          color: #fff;
          margin: 5px auto;

          @media screen and (max-width: 768px) {
            flex: 0 0 50%;
            font-size: 10px;
            margin: 0px auto;
            line-height: 40px;
            height: 40px;
            background-color: rgba(206, 161, 90, 0.5);
          }
        }

        .selectListOption.act {
          background-color: #fff;
          color: #cea15a;
          font-weight: 600;
        }
      }

      .optionBox {
        position: relative;
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        align-items: center;
        width: 90%;
        height: 100%;
        background-color: #fff;
        overflow: hidden;
        padding: 15px 0;

        @media screen and (max-width: 768px) {
          width: 100%;
          background-color: transparent;
          height: 300px;
        }

        .optionBoxItem {
          width: 871px;
          height: 84px;
          line-height: 40px;
          border-bottom: 1px solid #d8d8d8;
          position: relative;

          // margin: 0 auto;
          @media screen and (max-width: 768px) {
            width: 100%;
            height: 40px;
            margin: 5px auto;
            background-color: #fff;
            padding: 0 16px;
            overflow: hidden;
          }

          .tit {
            font-size: 16px;
            color: #202020;
            font-weight: 600;
            cursor: pointer;
            @media screen and (max-width: 768px) {
              color: #979797;
              font-size: 13px;
              font-weight: normal;
              text-overflow: ellipsis;
              word-break: keep-all;
              width: 75%;
              overflow: hidden;
            }
          }
          .tit:hover {
            color: #585858;
          }

          .text {
            font-size: 14px;
            color: #545454;
            width: 90%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            @media screen and (max-width: 768px) {
              display: none;
            }
          }

          .time {
            position: absolute;
            right: 0;
            top: 0;
            width: 60px;
            height: 44px;

            @media screen and (max-width: 768px) {
              width: auto;
              height: auto;
              right: 15px;
              font-size: 12px;
            }
          }
        }
      }
      .NoTextImg {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        top: 0;
        left: 0;
        img {
          margin: 20px 0;
          @media screen and (max-width: 768px) {
            width: 144px;
          }
        }
      }
    }

    .more {
      width: 120px;
      height: 32px;
      border: solid 1px #be9d6d;
      color: #be9d6d;
      line-height: 32px;
      text-align: center;
      margin: 30px auto 0 auto;
      font-weight: 600;
      cursor: pointer;
    }
  }

  .dynamic {
    position: relative;
    padding: 50px 0;
    height: auto;
    background: url("./../assets/home/dongtai.png") no-repeat;
    background-size: 300px;
    background-position: 95% 20%;

    @media screen and (max-width: 768px) {
      position: relative;
      padding: 24px 8px;
      height: auto;
    }

    .titleList {
      display: flex;
      justify-content: space-around;
      width: 1200px;
      margin: 0 auto;

      @media screen and (max-width: 768px) {
        width: 100%;
      }

      .title {
        color: #bd9d6c;
        font-size: 20px;
        text-align: center;
        margin-bottom: 28px;
        position: relative;
        cursor: pointer;

        @media screen and (max-width: 768px) {
          // display: flex;
          font-size: 16px;
          margin-bottom: 0px;
        }

        .title-CHname {
          font-weight: 600;

          @media screen and (max-width: 768px) {
            // margin-right: 10px;
          }
        }

        .title-ENname {
          line-height: 30px;
          margin-bottom: 15px;
          font-size: 18px;
        }

        .title-line {
          width: 35px;
          height: 1px;
          background-color: #bd9d6c;
          margin: 0 auto;

          @media screen and (max-width: 768px) {
            display: none;
          }
        }

        .arrow {
          display: none;

          @media screen and (max-width: 768px) {
            display: block;
            width: 23.3px;
            height: 14.33px;
            position: absolute;
            right: 0px;
            top: 10px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    .newdynamicBox {
      position: relative;
      display: flex;
      justify-content: space-between;
      width: 65%;
      margin: 0 auto;
      @media screen and (max-width: 1800px) {
        width: 75%;
      }
      @media screen and (max-width: 1600px) {
        width: 80%;
      }
      @media screen and (max-width: 1500px) {
        width: 95%;
      }
      @media screen and (max-width: 768px) {
        width: 100%;
        display: block;
      }
      .Box-item {
        width: 591px;
        height: 520px;
        border-radius: 5px;
        border: solid 1px #cea15a;
        @media screen and (max-width: 768px) {
          width: 100%;
          margin: 5px 0;
        }
        .title {
          padding-top: 30px;
          color: #bd9d6c;
          font-size: 20px;
          text-align: center;
          margin-bottom: 28px;
          position: relative;
          cursor: pointer;

          @media screen and (max-width: 768px) {
            // display: flex;
            font-size: 16px;
            margin-bottom: 0px;
          }

          .title-CHname {
            font-weight: 600;

            @media screen and (max-width: 768px) {
              // margin-right: 10px;
            }
          }

          .title-ENname {
            line-height: 30px;
            margin-bottom: 5px;
            font-size: 18px;
          }

          .title-line {
            width: 35px;
            height: 1px;
            background-color: #bd9d6c;
            margin: 0 auto;

            @media screen and (max-width: 768px) {
              display: none;
            }
          }

          .arrow {
            display: none;

            @media screen and (max-width: 768px) {
              display: block;
              width: 23.3px;
              height: 14.33px;
              position: absolute;
              right: 0px;
              top: 10px;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .lsit {
          position: relative;
          padding: 0 40px 30px 40px;
          .lsitItem {
            border-bottom: 1px solid #d8d8d8;
            line-height: 56px;
            height: 56px;
            overflow: hidden;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .ItemTitle {
              flex: 0 0 83%;
              height: 56px;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: keep-all;
              color: #202020;
              letter-spacing: 1px;
              white-space: nowrap;
              cursor: pointer;
            }
            .ItemTime {
              color: #908c86;
              font-size: 14px;
              height: 56px;

              padding-right: 5px;
              flex: 0 0 16%;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: keep-all;
            }
          }
        }
        .more {
          background-color: #cea15a;
          color: #fff;
        }
      }
      .content {
        flex: 0 0 45%;
        display: flex;
        // justify-content: space-between;
        align-items: center;
        flex-direction: column;
        position: relative;
        width: 1200px;
        margin: 0 auto;
        height: auto;
        @media screen and (max-width: 1300px) {
        }
        @media screen and (max-width: 768px) {
          width: 100%;
          position: relative;
          // padding: 24px 21px;
          height: auto;
        }

        .item {
          width: 100%;
          background-color: #fff;
          height: 50px;
          box-shadow: 0px 1px 1px 0px rgba(218, 218, 218, 0.3);
          display: flex;
          justify-content: flex-start;
          align-items: center;
          // flex: 0 0 25%;
          overflow: hidden;
          margin: 5px auto;

          .itemTIme {
            width: 60px;
            height: 50px;
            line-height: 15px;
            background-color: #cea15a;
            display: flex;
            align-items: center;
            text-align: center;
            color: #fff;
            margin-right: 20px;
            font-size: 12px;
            flex: 0 0 60px;
            padding: 0 10px;
            @media screen and (max-width: 768px) {
              flex: 0 0 50px;
              height: 50px;
              margin-right: 0px;
            }
          }

          .itemText {
            // width: 1018px;
            height: 50px;
            line-height: 25px;
            font-size: 12px;
            color: #ababab;
            text-overflow: ellipsis;
            overflow: hidden;

            .title {
              font-size: 14px;
              color: #878787;
              font-weight: 600;
              cursor: pointer;

              @media screen and (max-width: 768px) {
                font-size: 12px;
                font-weight: normal;
                padding: 0 10px;
              }
            }
          }
        }
      }
    }

    .more {
      width: 120px;
      height: 32px;
      border: solid 1px #be9d6d;
      color: #be9d6d;
      line-height: 32px;
      text-align: center;
      margin: 50px auto 0 auto;
      font-weight: 600;
      cursor: pointer;
    }
  }

  .consulting {
    position: relative;
    height: 539px;
    padding: 50px 0;
    @media screen and (max-width: 768px) {
      padding: 10px 0;
    }
    @media screen and (max-width: 768px) {
      position: relative;
      padding: 24px 21px;
      height: auto;
    }

    .title {
      color: #bd9d6c;
      font-size: 20px;
      text-align: center;
      margin-bottom: 28px;
      position: relative;

      @media screen and (max-width: 768px) {
        display: flex;
        font-size: 16px;
        margin-bottom: 0px;
      }

      .title-CHname {
        font-weight: 600;

        @media screen and (max-width: 768px) {
          margin-right: 10px;
        }
      }

      .title-ENname {
        line-height: 30px;
        margin-bottom: 15px;
        font-size: 18px;
      }

      .title-line {
        width: 35px;
        height: 1px;
        background-color: #bd9d6c;
        margin: 0 auto;

        @media screen and (max-width: 768px) {
          display: none;
        }
      }

      .arrow {
        display: none;

        @media screen and (max-width: 768px) {
          display: block;
          width: 23.3px;
          height: 14.33px;
          position: absolute;
          right: 0px;
          top: 10px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .content {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      width: 1200px;
      margin: 0 auto;

      @media screen and (max-width: 768px) {
        width: 100%;
        height: auto;
      }

      .Item-tel {
        width: 230px;
        height: 320px;
        box-shadow: 0px 1px 10px 0px rgba(222, 222, 222, 0.3);
        border-radius: 5px;
        border: solid 1px #bd9d6c;
        overflow: hidden;
        position: relative;

        @media screen and (max-width: 768px) {
          display: none;
        }

        .tel-Num {
          color: #bd9d6c;
          text-align: center;
          position: relative;
          z-index: 9999;
          font-weight: 600;

          > div:first-of-type {
            line-height: 70px;
          }
        }

        img {
          position: absolute;
          width: 120%;
          height: 120%;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .Item-from {
        width: 930px;
        height: 320px;
        background-color: #ffffff;
        box-shadow: 0px 1px 10px 0px rgba(222, 222, 222, 0.3);
        border-radius: 5px;
        border: solid 1px #bd9d6c;

        @media screen and (max-width: 768px) {
          width: 100%;
          height: auto;
          border: none;
          box-shadow: none;
        }

        .Item-flex {
          display: flex;

          @media screen and (max-width: 768px) {
            display: block;
          }

          .el-form-item {
            width: 380px;
            margin: 20px auto;

            @media screen and (max-width: 768px) {
              width: auto;
              margin: 10px auto;
              display: block;
            }

            .submit {
              background: #bd9d6c;
              border-radius: 2px;
              border: 1px solid #bd9d6c;
            }
          }
        }
      }
    }
  }
}
</style>
